import React, { useEffect } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Row, Col, Divider, InputNumber, FormInstance } from "antd";
import { useAppSelector } from "store/hook";

interface PeriodProps {
  SubmitConfigonFinish: (arg: any) => void;
  form: FormInstance<any>;
}

const BulkConfigFPeriod = React.memo(({ SubmitConfigonFinish, form }: PeriodProps) => {
  const { formData, selectedModel } = useAppSelector((state) => state.topology);
  const AliveNumberChange = (value: number) => {
    let newValue = Math.round(value / 30) * 30;
    form.setFieldsValue({ alive: newValue });
  };

  useEffect(() => {
    form.setFieldsValue({
      alive: formData?.report_period?.alive || 30,
      gps: formData?.report_period?.gps || 30,
      iot: formData?.report_period?.iot || 30,
      status: formData?.report_period?.status || 30,
      timeout: formData?.report_period?.timeout,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>Alive </h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"alive"}
              label="Alive Period (step by 30)"
              rules={[{ required: true, message: "required!" }]}
              initialValue={30}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="30"
                min={30}
                max={86400}
                step={30}
                onChange={AliveNumberChange}
              />
            </Form.Item>
            <h2>Status </h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"status"}
              label="Status Period"
              rules={[{ required: true, message: "required!" }]}
              initialValue={30}
            >
              <InputNumber style={{ width: "100%" }} placeholder="30" min={30} max={86400} step={30} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>IoT </h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"iot"}
              label="IoT Period"
              rules={[{ required: true, message: "required!" }]}
              initialValue={30}
            >
              <InputNumber style={{ width: "100%" }} placeholder="30" min={5} max={86400} step={30} />
            </Form.Item>
            {selectedModel !== "M335-W-A" && selectedModel !== "M335-W" && (
              <>
                <h2>GPS </h2>
                <Divider className={styles.divider} />
                <Form.Item
                  name={"gps"}
                  label="GPS Period"
                  rules={[{ required: true, message: "required!" }]}
                  initialValue={30}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="30" min={30} max={86400} step={30} />
                </Form.Item>
              </>
            )}

            {/* <Form.Item name={"gps"} rules={[{ required: true, message: "required!" }]} initialValue={30}></Form.Item> */}
          </Col>
        </Row>
      </div>
    </Form>
  );
});

export default BulkConfigFPeriod;

///////////////////////////////////////////////////////////////////////////////////////

export function assemble(values: any) {
  const report_period = {
    alive: values.alive,
    timeout: values.alive + 30,
    status: values.status,
    iot: values.iot,
    gps: values.gps,
  };

  return report_period;
}
